import React, { useEffect, useState } from 'react';
import {
  ACCEPTED_CHALLENGE_ONE_DAY_TO_GO,
  ACCEPTED_CHALLENGE_PROMPT,
  ACCEPT_CHALLENGE_PROMPT,
  AWAY_PROMPT,
  CAMP_CAPTAIN_IS_ONLINE,
  DAILY_CHECKINS_REPLY,
  DEPENDENT_CREATION_OF_THE_DAY,
  EXPLORE_NEW_CHALLENGE_PROMPT,
  HOWS_YOUR_DAY,
  NEW_CHALLENGE_PROMPT,
  NEW_CREATION_UPLOAD_PROMPT,
  UPCOMING_CAMP_30MINS_PROMPT,
  UPCOMING_CAMP_PROMPT,
} from '../../constants/companionPrompt.constants';
import { useAuth } from '../auth/Auth';
import EventEmitter from '../../utils/events';
import letsgoCharacterImg from '../../assets/images/campanion.svg';
import codyCharacterImg from '../../assets/images/cody.svg';
import domaCharacterImg from '../../assets/images/doma.svg';
import rootyCharacterImg from '../../assets/images/Rooty-companion.png';
import rushmoreCharacterImg from '../../assets/images/rushmore.svg';
import uniCharacterImg from '../../assets/images/uni.svg';
import './companion.-prompt.css';
import Lottie from 'react-lottie-player';
import uniJson from '../../assets/json/Uni.json';
import letsgoJson from '../../assets/json/letsgo.json';
import codyJson from '../../assets/json/cody.json';
import rootyJson from '../../assets/json/rooty.json';
import rushmoreJson from '../../assets/json/rushmore.json';
import domaJson from '../../assets/json/doma.json';
import {
  ANGRY,
  ANNOYED,
  CALM,
  CONFIDENT,
  EXCITED,
  HAPPY,
  SCARED,
  WORRIED,
} from '../../constants/moodType.constants';
import {
  ANGRY_REPLY,
  ANNOYED_REPLY,
  CALM_REPLY,
  CONFIDENT_REPLY,
  EXCITED_REPLY,
  GENERAL_REPLY,
  HAPPY_REPLY,
  SCARED_REPLY,
  WORRIED_REPLY,
} from '../../constants/checkinReply.constants';
import {
  CREATION_OF_THE_DAY_TEXT_1,
  CREATION_OF_THE_DAY_TEXT_2,
} from '../../constants/creation.constants';
import { useHistory } from 'react-router-dom';

const companionImages = {
  letsgo: letsgoCharacterImg,
  cody: codyCharacterImg,
  rushmore: rushmoreCharacterImg,
  doma: domaCharacterImg,
  rooty: rootyCharacterImg,
  uni: uniCharacterImg,
};

const companionJsons = {
  letsgo: letsgoJson,
  cody: codyJson,
  rushmore: rushmoreJson,
  doma: domaJson,
  rooty: rootyJson,
  uni: uniJson,
};

const CompanionPrompt = ({}) => {
  const history = useHistory();
  const { dependent } = useAuth();
  const [showPrompt, setShowPrompt] = useState('none');
  const [type, setType] = useState('');
  const [challenge, setChallenge] = useState('');
  const [campDays, setCampDays] = useState('');
  const [campMinutes, setCampMinutes] = useState('');
  const [isAns, setIsAns] = useState(false);
  const [mood, setMood] = useState(null);
  const [playUni, setPlayUni] = useState(false);
  const [creationOfThePromptText, setCreationOfThePromptText] = useState(
    CREATION_OF_THE_DAY_TEXT_1
  );
  const [homeUrl, setHomeUrl] = useState('');

  const handleShowPrompt = (data) => {
    setTimeout(() => {
      setShowPrompt(data.showPrompt);
    }, 700);
    setChallenge(data?.challenge);
    setType(data?.promptType);
    setCampDays(data?.days);
    setCampMinutes(data?.minutes);
    setMood(data?.mood);
  };

  const getCompanionImage = (friend) =>
    companionImages[friend] || letsgoCharacterImg;
  const getCheckInCompanionJson = (friend) =>
    companionJsons[friend] || letsgoJson;

  const getCompanionName = (type) => {
    const names = {
      letsgo: 'Letsgo',
      cody: 'Cody',
      rushmore: 'Rushmore',
      doma: 'Doma',
      rooty: 'Rooty',
      uni: 'Uni',
    };
    return names[type] || '';
  };

  const getDependentCompanion = () =>
    getCompanionImage(dependent?.profile?.taletree_friend);
  const getCheckInDependentCompanion = () =>
    getCheckInCompanionJson(dependent?.profile?.taletree_friend);
  const getChallengeCompanion = () =>
    getCompanionImage(challenge?.character_type);
  const handleClose = () => {
    EventEmitter.dispatch('show_prompt', { showPrompt: 'none' });
  };
  EventEmitter.subscribe('show_prompt', handleShowPrompt);

  useEffect(() => {
    return () => {
      EventEmitter.unsubscribe('show_prompt');
    };
  }, []);

  const getReply = () => {
    switch (mood) {
      case HAPPY:
        return HAPPY_REPLY;
      case EXCITED:
        return EXCITED_REPLY;
      case CALM:
        return CALM_REPLY;
      case ANNOYED:
        return ANNOYED_REPLY;
      case CONFIDENT:
        return CONFIDENT_REPLY;
      case SCARED:
        return SCARED_REPLY;
      case ANGRY:
        return `I can tell you're feeling bored, ${dependent?.username}. Everyone feels that way sometimes! How about we talk to your parents about it? They can help you find a way to work through it, and maybe you can do something fun together to lift your spirits.`;
      case WORRIED:
        return `I see that you're feeling worried ${dependent?.username}, and that’s okay. It might help to talk to someone you trust about what’s on your mind. Sometimes sharing your thoughts can make things feel a lot better.`;
      default:
        return `Thanks ${dependent?.username} for sharing your thoughts and feelings. It's wonderful to open our hearts to each other and have the courage to express ourselves. Remember, feelings come and go, and being aware of them helps us understand ourselves better.`;
    }
  };

  const handleNext = () => {
    setCreationOfThePromptText(CREATION_OF_THE_DAY_TEXT_2);
    setHomeUrl('/');
  };

  const promptContent = () => {
    let res;
    switch (type) {
      case HOWS_YOUR_DAY:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-1">
              <div className="campanion-tooltip">
                {!isAns ? (
                  <>
                    <h4>
                      Welcome back <strong>{dependent?.username}</strong> How is
                      your day going?
                    </h4>
                    <div className="select-mood">
                      <span
                        onClick={() => setIsAns(true)}
                        className="campanion-btn"
                      >
                        I’m doing great
                      </span>
                      <span
                        onClick={() => setIsAns(true)}
                        className="campanion-btn"
                      >
                        I’m so happy
                      </span>
                      <span
                        onClick={() => setIsAns(true)}
                        className="campanion-btn"
                      >
                        I’m sad today
                      </span>
                    </div>
                  </>
                ) : (
                  <h4>Here’s whats been happening since youve been away…</h4>
                )}
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case AWAY_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-2">
              <div className="campanion-tooltip">
                <h4>Here’s whats been happening since youve been away…</h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case EXPLORE_NEW_CHALLENGE_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Hey <strong>{dependent?.username}</strong> I’ve seen a
                  challenge by John Lake from Disney that I think you’ll really
                  love, Take a look:
                </h4>
                <span className="campanion-btn">
                  Explore this new challenge
                </span>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case ACCEPT_CHALLENGE_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getChallengeCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Hey <strong>{dependent?.username}</strong>! &nbsp;
                  {challenge?.character_type
                    ? `It's ${getCompanionName(
                        challenge?.character_type
                      )} here.`
                    : ''}
                  &nbsp;I’m so glad you chose this challenge.
                </h4>
                {/* Hey <strong>{dependent?.username}</strong>! It's Rooty here. I'm in charge of this challenge!
                                    I'll be here to help you. I love #{challenge?.tag_list[0] ? challenge?.tag_list[0] : 'taletree'} and Disney lets have some fun working on
                                    &nbsp;<span className='add-underline'>{challenge?.title}</span></h4> */}
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case ACCEPTED_CHALLENGE_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getChallengeCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  You can do this <strong>{dependent?.username}</strong> I
                  believe in you!
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case NEW_CHALLENGE_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Hey <strong>{dependent?.username}</strong>,&nbsp;
                  {`I think you will love the new challenge launched by ${
                    challenge?.created_by?.is_superuser
                      ? 'TaleTree'
                      : `${challenge?.created_by?.first_name} ${challenge?.created_by?.last_name}`
                  } from inside the ${
                    challenge?.created_by?.is_superuser
                      ? 'TaleTree'
                      : challenge?.treehouse_user?.name
                  } go check it out!`}
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case ACCEPTED_CHALLENGE_ONE_DAY_TO_GO:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getChallengeCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  You have one day to go, I know you can do it, we can’t wait to
                  see your creation.
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case NEW_CREATION_UPLOAD_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getChallengeCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Wow! You’re a creative genius! I can't wait to see what other
                  kids think about your creation.
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case UPCOMING_CAMP_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Camp is in {campDays} days, have you completed your challenge,
                  your tribe are excited to hear about your ideas.
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case UPCOMING_CAMP_30MINS_PROMPT:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Woohoo it's camp time with camp captain's name in{' '}
                  {campMinutes} mins!
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case CAMP_CAPTAIN_IS_ONLINE:
        res = (
          <div className="campanion-prompt-steps">
            <div className="campanion-charater-img">
              <img src={getDependentCompanion()} alt="" />
            </div>
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  Camp captain is in the common room! You can chat to your tribe
                  before camp.
                </h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case DAILY_CHECKINS_REPLY:
        res = (
          <div
            className="campanion-prompt-steps campanion-temp-prompt lottie-character lottie-uni"
            onMouseOut={() => setPlayUni(false)}
            onMouseOver={() => setPlayUni(true)}
          >
            <Lottie
              loop={true}
              play={true}
              animationData={getCheckInDependentCompanion()}
              className="lottie-character-wrapper"
            />
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>{getReply()}</h4>
                <span onClick={handleClose} className="tooltip-close">
                  ×
                </span>
              </div>
            </div>
          </div>
        );
        break;
      case 'temp':
        res = (
          <div
            className="campanion-prompt-steps campanion-temp-prompt lottie-character lottie-uni"
            onMouseOut={() => setPlayUni(false)}
            onMouseOver={() => setPlayUni(true)}
          >
            <Lottie
              loop={true}
              play={playUni}
              animationData={uniJson}
              className="lottie-character-wrapper"
            />
            {/* <div className="campanion-charater-img">
                            <img src={getDependentCompanion()} alt='' />
                        </div> */}
            <div className="map-tooltip">
              <div className="map-tooltip-inner">
                <h4>Temp</h4>
                {/* {/ <span onClick={handleClose} className='tooltip-close'>×</span> /} */}
              </div>
            </div>
          </div>
        );
        break;
      case DEPENDENT_CREATION_OF_THE_DAY:
        res = (
          <div className="campanion-prompt-steps campanion-temp-prompt lottie-character lottie-uni">
            <Lottie
              loop={true}
              play={true}
              animationData={getCheckInDependentCompanion()}
              className="lottie-character-wrapper"
            />
            <div className="campanion-prompt-steps-3">
              <div className="campanion-tooltip">
                <h4>
                  {creationOfThePromptText}
                  {homeUrl && (
                    <span
                      className="link-text"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        handleClose(), history.push('/');
                      }}
                    >
                      &nbsp; See your creation
                    </span>
                  )}
                </h4>

                {creationOfThePromptText === CREATION_OF_THE_DAY_TEXT_2 ? (
                  <span onClick={handleClose} className="tooltip-close">
                    ×
                  </span>
                ) : (
                  <span onClick={handleNext} className="tooltip-next-arrow">
                    →
                  </span>
                )}
              </div>
            </div>
          </div>
        );
        break;
      // default:
      //     res = (
      //         <div className="campanion-prompt-steps">
      //             <div className="campanion-charater-img">
      //                 <img src={getChallengeCompanion()} alt='' />
      //             </div>
      //             <div className="campanion-prompt-steps-3">
      //                 <div className="campanion-tooltip">
      //                     <h4>Wow! You’re a creative genius! I can't wait to see what other kids think about your creation.</h4>
      //                     <span onClick={handleClose} className='tooltip-close'>×</span>
      //                 </div>
      //             </div>
      //         </div>
      //     );
    }
    return res;
  };

  return (
    <div className="campanion-prompt" style={{ display: showPrompt }}>
      {promptContent()}
    </div>
  );
};

export default CompanionPrompt;
